module.exports = __webpack_public_path__ + "media/images/emblems/Le_Locle-coat_of_arms-9758da9094988215352e0737ddbe1adc.svg";